import { Products, Routes } from 'enums';
import { useHasLicense } from 'hooks/use-has-license';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { makeStyles } from 'tss-react/mui';
import FeatureItem from '../features/feature-overview/feature-item';
import ProductGroup from '../features/feature-overview/product-group';
import ContactPartnerDialog from '../features/motive-tests/contact-partner-dialog';

const MotiveTests: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasMotiveLicense = useHasLicense(Products.MOTIVE);
  const hasLeadLicense = useHasLicense(Products.LEAD);

  const [contactPartnerDialogOpen, setContactPartnerDialogOpen] = useState(false);

  const handleOpenContactPartnerDialog = () => {
    setContactPartnerDialogOpen(true);
  };

  const handleCloseContactPartnerDialog = () => {
    setContactPartnerDialogOpen(false);
  };

  return (
    <div className={classes.pageContainer}>
      <div className={classes.motiveTests}>
        <ProductGroup productGroup={undefined} productGroupName={t('motiveTests')}>
          <FeatureItem
            featureName={t('motiveAnalysis')}
            featureDescription={t('motiveAnalysisSubText')}
            action={hasMotiveLicense ? () => navigate(Routes.SURVEY_OVERVIEW) : handleOpenContactPartnerDialog}
          />
          <FeatureItem
            featureName={t('leadLeadershipFeedback')}
            featureDescription={t('leadSubText')}
            action={hasLeadLicense ? () => navigate(Routes.LEAD_CREATION) : handleOpenContactPartnerDialog}
          />
        </ProductGroup>
      </div>
      <ContactPartnerDialog open={contactPartnerDialogOpen} handleClose={handleCloseContactPartnerDialog} />
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  pageContainer: {
    minHeight: 'calc(100vh - 60px)',
  },
  motiveTests: {
    padding: theme.spacing(4, 3, 3, 6),
    maxWidth: '1200px',
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(3, 2),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
}));

export default MotiveTests;
